import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';

import MainLoader from '../components/Loader';
import useSignOut from '../hooks/useSignOut';

const Logout = () => {
  const { signOutAuto } = useSignOut();
  const { status, data } = useSession();
  const router = useRouter();
  const started = useRef(false);

  useEffect(() => {
    // Wait for the session to resolve before deciding what to do with it.
    if (status === 'loading' || started.current) return;
    started.current = true;
    // Already logged out — there's nothing to sign out. Go home instead of running
    // signOutAuto, which would leave the page stuck on the loader.
    if (status === 'unauthenticated') {
      router.replace('/');
      return;
    }
    // An errored session (ProvisioningError / RefreshAccessTokenError) is already
    // recovered by the app-wide BackendServiceProvider (→ /auth/error or /login).
    // Defer to it — a second signOut here would race and could land the user on
    // home instead of the intended recovery route.
    if (data?.error) return;
    signOutAuto();
  }, [status, data, signOutAuto, router]);

  return (
    <>
      <MainLoader />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'no-store, no-cache, must-revalidate, max-age=0',
  );

  return {
    props: {},
  };
};

export default Logout;
